import * as ACTIONTYPES from "../actionTypes";

export const initialState = {
  LoginDetails: {},
  AuthToken: "",
  isLogin: false,
  walletConnnected: "",
  isDarkTheme: false,
  ForgetEmail: "",
};
export default function auth(state = initialState, action) {
  switch (action.type) {
    case ACTIONTYPES.USERLOGIN:
      return {
        ...state,
        LoginDetails: action.payload,
        AuthToken: action.token,
        isLogin: action.isLogin,
      };

    case ACTIONTYPES.walletConnnected:
      return {
        ...state,
        walletConnnected: action.payload,
      };
    case ACTIONTYPES.DarkTheme:
      return {
        ...state,
        isDarkTheme: action.payload,
      };

    case ACTIONTYPES.ForgetEmail:
      return {
        ...state,
        ForgetEmail: action.payload,
      };

    default:
      return state;
  }
}
